import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsRsvpsPageController extends ContactsBaseDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/rsvps.js